import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import ExportButtonBase from '../exportButtonBase';

interface IExportButtonProps {
  exportButtonLabel?: string;
  handleExport: () => Promise<void>;
}

const ExportButton: React.FC<IExportButtonProps> = props => {
  const { handleExport, exportButtonLabel = 'Export' } = props;
  const [showIcon, setShowIcon] = useState(true);

  useEffect(() => {
    if (window.location.pathname.indexOf('/admin') > -1) {
      setShowIcon(false);
    }
  }, []);
  return showIcon ? <ExportButtonBase handleExport={handleExport} text={exportButtonLabel} /> : null;
};

const mapStateToProps = () => {
  return {};
};

export default connect(mapStateToProps)(ExportButton);
